import { client } from "utils";

export const getStatusRequest = () => client.get("status");
